import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import {
  useMensalidadesData,
  type MensalidadesData,
} from '@/hooks/useMensalidadesData';

const MensalidadesContext = createContext<MensalidadesData | null>(null);

export function MensalidadesProvider({ children }: { children: ReactNode }) {
  const value = useMensalidadesData();
  return <MensalidadesContext.Provider value={value}>{children}</MensalidadesContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useMensalidades(): MensalidadesData {
  const ctx = useContext(MensalidadesContext);
  if (!ctx) {
    throw new Error('useMensalidades deve ser usado dentro de <MensalidadesProvider>');
  }
  return ctx;
}
